export const SET = 'Analysis/data/answers/SET';

export function setAnswers(answers) {
  return {
    type: SET,
    answers
  }
}